"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import UiDialog from "../../../../components/dialog/UiDialog.vue";
import UiForm, { UiFormController } from "@/components/form/UiForm.vue";
import { UiFormAnnotations } from "@/components/form/annotations";
import PasswordInput from "@/views/accountItems/components/PasswordInput.vue";
import Question from "@/components/Question.vue";
import QuestionSlot from "@/components/QuestionSlot.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import { RolelistModel } from "@/models/rolelist.model";
import API from "@ym-framework/api-utils";
import i18n from "@/lang";
import _ from "lodash";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import AccountBindShop from "@/views/teamItems/components/dialog/AccountBindShop.vue";
import { AccountSessionMixins } from "@/service/account-session";
export class formController extends UiFormController {
  constructor() {
    super(...arguments);
    this.account = "";
    this.name = "";
    // 加入一个正则校验，可为空，但只要输入内容，则至少包含一位字母且仅限数字或字母
    // @UiFormAnnotations.Rule([
    //   {
    //     validator: (rule: any, value: string, callback: any) => {
    //       if (!value || value === "") {
    //         return callback(true);
    //       }
    //       if (!/^(?=.*[a-zA-Z]).*$/.test(value) || !/^(?=.*\d).*$/.test(value)) {
    //         return callback(new Error(i18n.t("team_management.edit_subcount.loginaccount.message") as string));
    //       }
    //       return callback(true);
    //     },
    //     message: i18n.t("team_management.edit_subcount.loginaccount.message") as string,
    //     trigger: "blur",
    //   },
    // ])
    this.loginaccount = "";
    this.password = "";
    this.role = "";
    this.department = [];
    this.remark = null;
    this.device_limit = "all_device_permanent";
    this.device_date = "all_date_permanent";
    this.start_time = "00:00";
    this.end_time = "23:59";
    this.powers = [];
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("team_management.edit_subcount.name.message"),
      trigger: "blur"
    }
  ])
], formController.prototype, "name", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "team_management.edit_subcount.password.message"
      ),
      trigger: "blur"
    }
  ])
], formController.prototype, "password", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("team_management.edit_subcount.role.message"),
      trigger: "blur"
    }
  ])
], formController.prototype, "role", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "team_management.edit_subcount.department.message"
      ),
      trigger: "blur"
    }
  ])
], formController.prototype, "department", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "team_management.login_restrictions.dialog.equipment_limit.message"
      ),
      trigger: "blur"
    }
  ])
], formController.prototype, "device_limit", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "team_management.login_restrictions.dialog.time_limit.message"
      ),
      trigger: "blur"
    }
  ])
], formController.prototype, "device_date", 2);
let UserLoginLimit = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.role_options = [];
    this.all_department = [];
    this.choose_shops = [];
    this.submit_loading = false;
    this.powers_item = [
      {
        key: "VD_NEW",
        name: this.$t("team_management.other_way.dialog.vd_new")
      },
      {
        key: "VD_RENEW",
        name: this.$t("team_management.other_way.dialog.vd_renew")
      },
      {
        key: "RECHARGE_COIN",
        name: this.$t("team_management.other_way.dialog.recharge_coin")
      },
      {
        key: "VD_UPGRADE",
        name: this.$t("team_management.other_way.dialog.vd_upgrade")
      },
      {
        key: "VIEW_ORDER_DETAIL",
        name: this.$t("team_management.other_way.dialog.view_order_detail")
      },
      {
        key: "SELECT_SHOP_PASSWORD",
        name: this.$t("team_management.other_way.dialog.select_shop_password")
      },
      // {
      //   key: "EDIT_SHOP_PASSWORD",
      //   name: this.$t("team_management.other_way.dialog.edit_shop_password"),
      // },
      {
        key: "PLUG_MANAGEMENT",
        name: this.$t("team_management.action_power.dialog.extensions_manager"),
        question: this.$t(
          "team_management.action_power.dialog.extensions_manager_question"
        )
      },
      {
        key: "PLUG_MANAGEMENT_PERSON",
        name: this.$t("team_management.action_power.dialog.extensions_install"),
        question: this.$t(
          "team_management.action_power.dialog.extensions_install_question"
        )
      },
      {
        key: "VIDEO_AUTH",
        name: this.$t("team_management.action_power.dialog.add_video")
      },
      {
        key: "SHOP_EDIT",
        name: this.$t("team_management.action_power.shop_edit")
      },
      {
        key: "PASSWORD_EDIT",
        name: this.$t("team_management.other_way.dialog.allow_edit")
      },
      {
        key: "COOKIE_BACKUP",
        name: this.$t("team_management.other_way.dialog.cookie_backup")
      },
      {
        key: "VD_LIST_MODE_INVISIBLE",
        name: this.$t("team_management.other_way.dialog.vd_list_mode")
      },
      {
        key: "VD_NAME_INVISIBLE",
        name: this.$t("team_management.other_way.dialog.vd_name_invisible")
      },
      {
        key: "SHOP_CREATE",
        name: this.$t("team_management.other_way.dialog.shop_create")
      },
      {
        key: "FORBIDDEN_AUTH_VD_MANAGER",
        name: this.$t(
          "team_management.other_way.dialog.forbidden_auth_vd_manager"
        )
      },
      {
        key: "ADMIN_DISALLOW_MODIFY_SELF_POWER",
        name: this.$t("team_management.other_way.dialog.admin_disallow_modify_self_power")
      }
    ];
    this.props = {
      multiple: true,
      emitPath: false,
      value: "id",
      checkStrictly: true
    };
    this.controller = new formController();
    this.sub_account = new RolelistModel();
  }
  formatdata(data) {
    return __async(this, null, function* () {
      for (let item of data) {
        if (item.hasOwnProperty("children") === false) {
          continue;
        }
        if (item.children === null) {
          delete item.children;
          continue;
        }
        if (item.children.length === 0) {
          delete item.children;
          continue;
        }
        if (item.children !== void 0 && item.children.length > 0) {
          this.formatdata(item.children);
        }
      }
      return data;
    });
  }
  open(item) {
    return __async(this, null, function* () {
      if (this.$session.marks.is("OPEN_API")) {
        this.powers_item = [
          {
            key: "VD_NEW",
            name: this.$t("team_management.other_way.dialog.vd_new")
          },
          {
            key: "VD_RENEW",
            name: this.$t("team_management.other_way.dialog.vd_renew")
          },
          {
            key: "RECHARGE_COIN",
            name: this.$t("team_management.other_way.dialog.recharge_coin")
          },
          {
            key: "VD_UPGRADE",
            name: this.$t("team_management.other_way.dialog.vd_upgrade")
          },
          {
            key: "VIEW_ORDER_DETAIL",
            name: this.$t("team_management.other_way.dialog.view_order_detail")
          },
          {
            key: "SELECT_SHOP_PASSWORD",
            name: this.$t(
              "team_management.other_way.dialog.select_shop_password"
            )
          },
          // {
          //   key: "EDIT_SHOP_PASSWORD",
          //   name: this.$t("team_management.other_way.dialog.edit_shop_password"),
          // },
          {
            key: "PLUG_MANAGEMENT",
            name: this.$t("team_management.action_power.dialog.extensions_manager"),
            question: this.$t(
              "team_management.action_power.dialog.extensions_manager_question"
            )
          },
          {
            key: "PLUG_MANAGEMENT_PERSON",
            name: this.$t("team_management.action_power.dialog.extensions_install"),
            question: this.$t(
              "team_management.action_power.dialog.extensions_install_question"
            )
          },
          {
            key: "VIDEO_AUTH",
            name: this.$t("team_management.action_power.dialog.add_video")
          },
          {
            key: "SHOP_EDIT",
            name: this.$t("team_management.action_power.shop_edit")
          },
          {
            key: "PASSWORD_EDIT",
            name: this.$t("team_management.other_way.dialog.allow_edit")
          },
          {
            key: "COOKIE_BACKUP",
            name: this.$t("team_management.other_way.dialog.cookie_backup")
          },
          {
            key: "OPEN_API",
            name: this.$t("team_management.action_power.open_api")
          },
          {
            key: "VD_LIST_MODE_INVISIBLE",
            name: this.$t("team_management.other_way.dialog.vd_list_mode")
          },
          {
            key: "VD_NAME_INVISIBLE",
            name: this.$t("team_management.other_way.dialog.vd_name_invisible")
          },
          {
            key: "SHOP_CREATE",
            name: this.$t("team_management.other_way.dialog.shop_create")
          },
          {
            key: "FORBIDDEN_AUTH_VD_MANAGER",
            name: this.$t(
              "team_management.other_way.dialog.forbidden_auth_vd_manager"
            )
          },
          {
            key: "ADMIN_DISALLOW_MODIFY_SELF_POWER",
            name: this.$t("team_management.other_way.dialog.admin_disallow_modify_self_power")
          }
        ];
      } else {
        this.powers_item = [
          {
            key: "VD_NEW",
            name: this.$t("team_management.other_way.dialog.vd_new")
          },
          {
            key: "VD_RENEW",
            name: this.$t("team_management.other_way.dialog.vd_renew")
          },
          {
            key: "RECHARGE_COIN",
            name: this.$t("team_management.other_way.dialog.recharge_coin")
          },
          {
            key: "VD_UPGRADE",
            name: this.$t("team_management.other_way.dialog.vd_upgrade")
          },
          {
            key: "VIEW_ORDER_DETAIL",
            name: this.$t("team_management.other_way.dialog.view_order_detail")
          },
          {
            key: "SELECT_SHOP_PASSWORD",
            name: this.$t(
              "team_management.other_way.dialog.select_shop_password"
            )
          },
          // {
          //   key: "EDIT_SHOP_PASSWORD",
          //   name: this.$t("team_management.other_way.dialog.edit_shop_password"),
          // },
          {
            key: "PLUG_MANAGEMENT",
            name: this.$t("team_management.action_power.dialog.extensions_manager"),
            question: this.$t(
              "team_management.action_power.dialog.extensions_manager_question"
            )
          },
          {
            key: "PLUG_MANAGEMENT_PERSON",
            name: this.$t("team_management.action_power.dialog.extensions_install"),
            question: this.$t(
              "team_management.action_power.dialog.extensions_install_question"
            )
          },
          {
            key: "VIDEO_AUTH",
            name: this.$t("team_management.action_power.dialog.add_video")
          },
          {
            key: "SHOP_EDIT",
            name: this.$t("team_management.action_power.shop_edit")
          },
          {
            key: "PASSWORD_EDIT",
            name: this.$t("team_management.other_way.dialog.allow_edit")
          },
          {
            key: "COOKIE_BACKUP",
            name: this.$t("team_management.other_way.dialog.cookie_backup")
          },
          {
            key: "VD_LIST_MODE_INVISIBLE",
            name: this.$t("team_management.other_way.dialog.vd_list_mode")
          },
          {
            key: "VD_NAME_INVISIBLE",
            name: this.$t("team_management.other_way.dialog.vd_name_invisible")
          },
          {
            key: "SHOP_CREATE",
            name: this.$t("team_management.other_way.dialog.shop_create")
          },
          {
            key: "FORBIDDEN_AUTH_VD_MANAGER",
            name: this.$t(
              "team_management.other_way.dialog.forbidden_auth_vd_manager"
            )
          },
          {
            key: "ADMIN_DISALLOW_MODIFY_SELF_POWER",
            name: this.$t("team_management.other_way.dialog.admin_disallow_modify_self_power")
          }
        ];
      }
      let account_info = yield API.get(
        `api://base.auth/api/v8/users/${item.guid}`
      );
      this.sub_account = item;
      let result = yield API.get(`api://base.auth/api/v1/roles`);
      this.role_options = result.data.datas;
      let response = yield API.get(`api://base.auth/api/v1/departments`);
      let arr = [];
      arr.push(response.data);
      arr = yield this.formatdata(arr);
      this.all_department = arr;
      let dep_ids = [];
      for (let data of item.department) {
        dep_ids.push(data.id);
      }
      let shop_response = yield API.get(
        `api://base.auth.pro/v1/user/${item.guid}/auth-shops`
      );
      this.choose_shops = this.formatShops(shop_response.data.datas);
      this.controller.account = item.account;
      this.controller.name = item.name;
      this.controller.password = account_info.data.original_password;
      this.controller.role = item.role;
      this.controller.department = dep_ids;
      this.controller.remark = item.comment ? item.comment : null;
      this.controller.device_limit = account_info.data.login_limit.device_limit;
      this.controller.powers = account_info.data.powers;
      this.controller.device_date = account_info.data.login_limit.date_limit;
      this.controller.end_time = account_info.data.login_limit.end_time_limit;
      this.controller.start_time = account_info.data.login_limit.start_time_limit;
      this.controller.loginaccount = account_info.data.login_name ? account_info.data.login_name : "";
      this._edit_account.show();
    });
  }
  formatShops(datas) {
    let shops = [];
    for (let shop of datas) {
      let item = {
        id: shop.oldId,
        label: shop.name
      };
      shops.push(item);
    }
    return shops;
  }
  setShops(datas) {
    this.choose_shops = datas.datas;
  }
  getShops(item) {
    if (item.length > 0) {
      let arr = [];
      for (let data of item) {
        arr.push(data.label);
      }
      return arr.join(",");
    }
    return this.$t("virtualdesktopform.choose_users");
  }
  openSplitShop() {
    this._edit_bind_shop.open_new(this.choose_shops);
  }
  submit() {
    return __async(this, null, function* () {
      try {
        if (this.controller.loginaccount !== null && this.controller.loginaccount !== "") {
          if (!/^(?=.*[A-Za-z])[A-Za-z0-9]+$/.test(this.controller.loginaccount)) {
            this.$message.error(i18n.t("team_management.edit_subcount.loginaccount.message"));
            return;
          }
        }
        this.submit_loading = true;
        let _role_choose = _.find(this.role_options, {
          id: this.controller.role
        });
        if (_role_choose !== void 0 && _role_choose.name === "\u7BA1\u7406\u5458") {
          yield UiConfirm.confirm(
            this.$t("team_management.edit_subcount.confirm.content"),
            this.$t("team_management.edit_subcount.confirm.title"),
            {
              confirmButtonText: this.$t("team_management.confirm"),
              cancelButtonText: this.$t("shopdefaultview.cancel")
            }
          );
        }
        let shop_ids = [];
        for (let item of this.choose_shops) {
          shop_ids.push(item.id);
        }
        yield API.put(`api://base.auth/api/v8/users/${this.sub_account.guid}`, {
          account: this.controller.account,
          name: this.controller.name,
          original_password: this.controller.password,
          comment: this.controller.remark,
          role: this.controller.role,
          departments: this.controller.department,
          login_limit: {
            date_limit: this.controller.device_date,
            device_limit: this.controller.device_limit,
            start_time_limit: this.controller.start_time,
            end_time_limit: this.controller.end_time
          },
          powers: this.controller.powers,
          shops: shop_ids,
          login_name: this.controller.loginaccount !== "" && this.controller.loginaccount !== null ? this.controller.loginaccount : null
        });
        this.$emit("success");
        this._edit_account.hide();
        this.submit_loading = false;
      } catch (error) {
        this.submit_loading = false;
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("bind-account-shop")
], UserLoginLimit.prototype, "_edit_bind_shop", 2);
__decorateClass([
  Ref("edit-account-dialog")
], UserLoginLimit.prototype, "_edit_account", 2);
UserLoginLimit = __decorateClass([
  Component({
    components: {
      Question,
      PasswordInput,
      UiForm,
      UiDialog,
      UiSubmit,
      QuestionSlot,
      AccountBindShop
    }
  })
], UserLoginLimit);
export {
  UserLoginLimit as default
};
